const ccAction = action => `CITIES_COMMUNITIES/${action}`;

// Zones
const GET_ZONES = ccAction('GET_ZONES');
const GET_ZONES_SUCCESS = ccAction('GET_ZONES_SUCCESS');
const GET_ZONES_FAILURE = ccAction('GET_ZONES_FAILURE');

const CREATE_ZONE = ccAction('CREATE_ZONE');
const CREATE_ZONE_SUCCESS = ccAction('CREATE_ZONE_SUCCESS');
const CREATE_ZONE_FAILURE = ccAction('CREATE_ZONE_FAILURE');

const UPDATE_ZONE = ccAction('UPDATE_ZONE');
const UPDATE_ZONE_SUCCESS = ccAction('UPDATE_ZONE_SUCCESS');
const UPDATE_ZONE_FAILURE = ccAction('UPDATE_ZONE_FAILURE');

const DELETE_ZONE = ccAction('DELETE_ZONE');
const DELETE_ZONE_SUCCESS = ccAction('DELETE_ZONE_SUCCESS');
const DELETE_ZONE_FAILURE = ccAction('DELETE_ZONE_FAILURE');

// Assessment
const RUN_ASSESSMENT = ccAction('RUN_ASSESSMENT');
const RUN_ASSESSMENT_SUCCESS = ccAction('RUN_ASSESSMENT_SUCCESS');

// UBHPS features
const GET_UBHPS_FEATURES = ccAction('GET_UBHPS_FEATURES');
const GET_UBHPS_FEATURES_SUCCESS = ccAction('GET_UBHPS_FEATURES_SUCCESS');
const GET_UBHPS_FEATURES_FAILURE = ccAction('GET_UBHPS_FEATURES_FAILURE');

const UPDATE_UBHPS_FEATURES = ccAction('UPDATE_UBHPS_FEATURES');
const UPDATE_UBHPS_FEATURES_SUCCESS = ccAction('UPDATE_UBHPS_FEATURES_SUCCESS');
const UPDATE_UBHPS_FEATURES_FAILURE = ccAction('UPDATE_UBHPS_FEATURES_FAILURE');

// Impact model
const SET_COMMUNITY_IMPACT = ccAction('SET_COMMUNITY_IMPACT');

export default {
  GET_ZONES, GET_ZONES_SUCCESS, GET_ZONES_FAILURE,
  CREATE_ZONE, CREATE_ZONE_SUCCESS, CREATE_ZONE_FAILURE,
  UPDATE_ZONE, UPDATE_ZONE_SUCCESS, UPDATE_ZONE_FAILURE,
  DELETE_ZONE, DELETE_ZONE_SUCCESS, DELETE_ZONE_FAILURE,
  RUN_ASSESSMENT, RUN_ASSESSMENT_SUCCESS,
  GET_UBHPS_FEATURES, GET_UBHPS_FEATURES_SUCCESS, GET_UBHPS_FEATURES_FAILURE,
  UPDATE_UBHPS_FEATURES, UPDATE_UBHPS_FEATURES_SUCCESS, UPDATE_UBHPS_FEATURES_FAILURE,
  SET_COMMUNITY_IMPACT,
};
